import {Actions, StateChanges} from './stateChanges'
import {StoreConfig} from './storeConfig'
import axios from 'axios'


const serverUrl = StoreConfig.serverUrl
const visualizerUrl = StoreConfig.visualizerUrl
const tanachSearchServerUrl = StoreConfig.tanachSearchServerUrl
const talmudSearchServerUrl = StoreConfig.talmudServerUrl
const preTokenize = StoreConfig.preTokenize

axios.defaults.headers = {
  'Content-Type': 'text/plain;charset=UTF-8',
}
const axiosInstance = axios.create({timeout: 60000})

const modes = ['tanakh', 'mishna', 'talmud']
var actionsData, directMatch
async function doModeCall(commit, dispatch, textForApi, mode) {
  let tokenizationResponse
  if (preTokenize) tokenizationResponse = await axiosInstance.post(
    'https://tokenizer-1-1.loadbalancer.dicta.org.il/api',
    {data: textForApi, genre: 'Rabbinic'}
  )
  // console.log('tokenizationResponse:')
  // console.log(tokenizationResponse)
  let requestObj = {
    mode: mode,
    thresh: 0,
    fdirectonly: directMatch
  }
  if (preTokenize) {
    requestObj['tokens'] = tokenizationResponse.data
  } else requestObj['data'] = textForApi
  axiosInstance.post(serverUrl+'/markpsukim', JSON.stringify(requestObj))
  .then(function (response) {
    actionsData[mode] = response.data
    commit('SET_' + mode.toUpperCase() + '_RESULTS', 
      preTokenize ? response.data.data.markPesukimResults : response.data.results
    )
    if (Object.values(actionsData).every(v => v)) {
      let dataForCommit = actionsData[modes[0]] // start with Tanakh, for consistent ORDER if non-token
      modes.slice(1).forEach(mode => {
        // console.log('dataForCommit:')
        // console.log(dataForCommit)
        // console.log('actionsData[mode]:')
        // console.log(actionsData[mode])
        if (preTokenize) {
          Object.assign(dataForCommit.data.markPesukimResults, actionsData[mode].data.markPesukimResults)
        } else dataForCommit.results = dataForCommit.results.concat(actionsData[mode].results) // concat other RESULTS
      })
      commit(StateChanges.SET_ALL_RESULTS,
        preTokenize ? dataForCommit.data.markPesukimResults : dataForCommit.results
      )
      if (preTokenize) dataForCommit = Object.assign({}, dataForCommit, {
        allText: dataForCommit.data.markPesukimResults.allText
      })
      commit(StateChanges.SET_DATA, dataForCommit) // i.e. a potential "parse" payload, which HAPPENS to have "all" results
      dispatch(Actions.RUN_PARSE)
      commit(StateChanges.SET_SERVER_ERROR, null)
    }
  })
  .catch(function (error) {
    console.log(error)
    commit(StateChanges.SET_SERVER_ERROR, error.message)
  }) 
}

export default {
  [Actions.RUN_FOOTNOTES]: function ({commit, state, dispatch}) {
    let textForApi = state.textForApiCall
    if (textForApi) {
      commit(StateChanges.FOOTNOTES_COMPLETE, false)
      actionsData = Object.fromEntries(modes.map(m => [m, null]))
      directMatch = state.directMatch
      modes.forEach(mode => {
        doModeCall(commit, dispatch, textForApi, mode)
      })
    } else {
      console.log('Invalid input.')
    }
  },
  [Actions.RUN_CHAPTERS]: function ({commit, state}) {
    var mode = state.verseForChapter.mode
    var verseId = state.verseForChapter.verseId
    var verseiWords = state.verseForChapter.verseiWords
    var verseDispHeb = state.verseForChapter.verseDispHeb
    axiosInstance.post(serverUrl+'/getchaptertext', JSON.stringify({
      verseId: verseId,
      verseiWords: verseiWords,
      mode: mode,
      verseDispHeb: verseDispHeb
    }))
    .then(function (response) {
      commit(StateChanges.SET_CHAPTER_RESULTS, JSON.parse(response.data)) 
    })
    .catch(function (error) {
      console.log(error)
      
    })    

  },

  [Actions.RUN_PARSE]: function ({commit, state, dispatch}) {
    commit(StateChanges.FOOTNOTES_COMPLETE, false)
    var minRange = state.minRange
    var maxRange = state.maxRange
    const resultsType = state.mode === -1 ? 'allResults'
      : ['tanakhResults', 'talmudResults', 'mishnaResults'][state.mode]
    if (preTokenize) {
      state.data.data.markPesukimResults = state[resultsType]
    } else state.data.results = state[resultsType]
    let copyOfStateData = Object.assign({}, state.data)
    if (preTokenize) delete copyOfStateData.allText // "allText copy" in state.data only for FootnoteDisplay.vue
    let requestObj = preTokenize ? { tokenized: copyOfStateData } : copyOfStateData
    requestObj['keepredundant'] = true
    const requestJson = JSON.stringify(requestObj)
    axiosInstance.post(serverUrl+'/parsetogroups?smin='+minRange+'&smax='+maxRange, requestJson)
    .then(function (response) {
      //check if mode set
      const responseData = preTokenize ? response.data.data.citationResults : response.data
      commit(StateChanges.SET_SELECTED_RESULTS, responseData)  
      if(responseData.length == 0) {
        //change min range
        minRange = 0
        axiosInstance.post(serverUrl+'/parsetogroups?smin='+minRange+'&smax='+maxRange, requestJson)
        .then(function (response) {
          const responseData = preTokenize ? response.data.data.citationResults : response.data
          if(responseData.length > 0) {
            commit(StateChanges.SET_LOWER_THRESHOLD_RESULTS, true)  
            commit(StateChanges.SET_NO_RESULTS, false )
          } else{  
            //change max range
            minRange = state.minRange
            maxRange = 1000
            axiosInstance.post(serverUrl+'/parsetogroups?smin='+minRange+'&smax='+maxRange, requestJson)
            .then(function (response) {
              const responseData = preTokenize ? response.data.data.citationResults : response.data
              if(responseData.length > 0) {
                commit(StateChanges.SET_HIGHER_THRESHOLD_RESULTS, true)  
                commit(StateChanges.SET_NO_RESULTS, false )
              } else {
                commit(StateChanges.SET_NO_RESULTS, true)
                dispatch(Actions.RUN_TANAKH_SEARCH)  
                dispatch(Actions.RUN_TALMUD_SEARCH)    
              }
            })
            .catch(function (error) {
              console.log(error)
            })
         }
        })
        .catch(function (error) {
          console.log(error)
          commit(StateChanges.SET_SERVER_ERROR, error.message)
        }) 
      
      } else {
        //re-init other results
        commit(StateChanges.SET_NO_RESULTS, false)  
        commit(StateChanges.SET_LOWER_THRESHOLD_RESULTS, false) 
        commit(StateChanges.SET_HIGHER_THRESHOLD_RESULTS, false)  
        if(state.visualizerView)
          dispatch(Actions.RUN_VISUALIZER)        
      }
      commit(StateChanges.FOOTNOTES_COMPLETE, true)       
    })
    .catch(function (error) {
      console.log(error)
    })    
  },

  [Actions.DOWNLOAD_RESULTS]: function ({state}) {
    var minRange = state.minRange
    var maxRange = state.maxRange
    axiosInstance.post(serverUrl+'/wordoutput?smin='+minRange+'&smax='+maxRange,
    JSON.stringify(state.data), {responseType: 'arraybuffer'})
    .then(function (response) {
      Date.prototype.yyyymmdd = function() {

        let mm = this.getMonth() + 1; // getMonth() is zero-based
        let dd = this.getDate();

        return [this.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('');
      };

      let date = new Date();
    
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "DictaCitationFinder-"+date.yyyymmdd()+".docx"); //or any other extension
      
      document.body.appendChild(link);
      link.click();
    })
    .catch(function (error) {
      console.log(error)
    })  
  },

  
  [Actions.RUN_VISUALIZER]: function ({commit, state}) {
    let axiosConfig = {
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
          "Access-Control-Allow-Origin": "*",
      }
    }
    var textForApi = state.textForApiCall
    axiosInstance.post(visualizerUrl,
      JSON.stringify({
        text: textForApi,
        json: JSON.stringify(state.selectedResults),
        mode: state.visualizerModes 
      })
    , axiosConfig)
    .then(function (response) {
      commit(StateChanges.SET_VISUALIZER_RESULTS, response.data.currentDT)  
    })
    .catch(function (error) {
      console.log(error)
    })    
  },
  
  
  [Actions.RUN_TALMUD_SEARCH]: function ({commit, state}) {
    let axiosConfig = {
      headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          "Access-Control-Allow-Origin": "*",
      }
    }
    var textForApi = state.textForApiCall
    axiosInstance.post(talmudSearchServerUrl, {
      query: textForApi,
      from : 0, 
      size : 10
    }, axiosConfig)
    .then(function (response) {
      commit(StateChanges.SET_EXTERNAL_TALMUD_RESULTS, response.data.total)  
    })
    .catch(function (error) {
      console.log(error)
    })    
  },

  [Actions.RUN_TANAKH_SEARCH]: function ({commit, state}) {
    let axiosConfig = {
      headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          "Access-Control-Allow-Origin": "*",
      }
    }

    var textForApi = state.textForApiCall
    axiosInstance.post(tanachSearchServerUrl, {
      query: textForApi,
      from : 0, 
      size : 10
    }, axiosConfig)
    .then(function (response) {
      commit(StateChanges.SET_EXTERNAL_TANAKH_RESULTS, response.data.total)  
    })
    .catch(function (error) {
      console.log(error)
    })    
  }
}
